import * as React from 'react'
import Stack from '@mui/material/Stack'
import { ENTITY_TYPES } from '@sales-center/common'
import { ExploratoryMapNew } from '@user/features/MapView/MapViewDialog/ExploratoryMapNew/ExploratoryMapNew'

export type MapViewDialogContentProps = {
  open: boolean
  onClose: () => void
  center?: H.geo.Point
  entityId?: number
  entityType?: ENTITY_TYPES
  serviceLocationId?: number
  searchDrawerOpen: boolean
  filterDrawerOpen: boolean
  addLeadDrawerOpen: boolean
  setSearchDrawerOpen: (open: boolean) => void
  setFilterDrawerOpen: (open: boolean) => void
  setAddLeadDrawerOpen: (open: boolean) => void
  zoom?: number
}

export function MapViewDialogContent(props: MapViewDialogContentProps) {
  return (
    <Stack height="100%" width="100%" minHeight={0}>
      {/*<ExploratoryMap {...props} />*/}
      <ExploratoryMapNew {...props} />
    </Stack>
  )
}
